import { UserPermissions } from "core/enum";
import { BasePresenter } from "core/presenter";

class PermissionsFieldsPresenter extends BasePresenter {
  initialState() {
    return {
      permissions: [],
      mode: ""
    };
  }

  buildPermissionsFormList(enabledPermissions) {
    const permissions = [];

    for (let permission in UserPermissions) {
      permissions.push({
        field: UserPermissions[permission],
        value: enabledPermissions.includes(permission)
      });
    }

    return permissions;
  }

  async onComponentReady(currentUserPermissions, formPermissions) {
    const enabledPermissions = formPermissions || currentUserPermissions;

    this.viewModel.permissions = this.buildPermissionsFormList(
      enabledPermissions
    );
  }

  getEnabledPermissionsKeys(enabledPermissions) {
    const userPermissionsKeys = Object.keys(UserPermissions);

    return enabledPermissions.map(permission =>
      userPermissionsKeys.find(key => UserPermissions[key] === permission.field)
    );
  }

  changePermissions(field, value) {
    return this.viewModel.permissions.map(permission => {
      if (permission.field === field) {
        permission.value = value;
      }
      return permission;
    });
  }

  onCheck(field, value) {
    const permissions = this.changePermissions(field, value);
    const enabledPermissions = permissions.filter(
      permission => permission.value
    );
    const enabledPermissionsKeys = this.getEnabledPermissionsKeys(
      enabledPermissions
    );

    this.viewModel.permissions = permissions;

    return enabledPermissionsKeys;
  }
}

export default PermissionsFieldsPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/general-info/permissions-fields/permissions-fields.presenter.js